var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q-a"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29955",
    "data-name": "Rectangle 29955",
    width: 16,
    height: 16,
    transform: "translate(26 222)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_834",
    "data-name": "Mask Group 834",
    transform: "translate(-26 -222)",
    clipPath: "url(#q-a)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-06-14T144927.708",
    "data-name": "svgexport-6 - 2022-06-14T144927.708",
    transform: "translate(26 222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27457",
    "data-name": "Path 27457",
    d: "M11.481,7.247a.469.469,0,1,1-.469-.469A.469.469,0,0,1,11.481,7.247Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27458",
    "data-name": "Path 27458",
    d: "M11.012,2.259A1.723,1.723,0,0,0,9.289,3.983h0a.469.469,0,1,0,.937,0,.786.786,0,1,1,.786.787.469.469,0,0,0-.469.469v.5a.469.469,0,1,0,.937,0v-.1a1.724,1.724,0,0,0-.469-3.383Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27459",
    "data-name": "Path 27459",
    d: "M4.5,11.963a2.477,2.477,0,1,0-3.038,0A2.976,2.976,0,0,0,0,14.527v1A.469.469,0,0,0,.469,16H5.49a.469.469,0,0,0,.469-.469v-1A2.976,2.976,0,0,0,4.5,11.963ZM1.44,10.008a1.54,1.54,0,1,1,1.54,1.54,1.541,1.541,0,0,1-1.54-1.54Zm3.581,5.054H.938v-.535a2.042,2.042,0,1,1,4.083,0v.535Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27460",
    "data-name": "Path 27460",
    d: "M14.025,0H8A1.974,1.974,0,0,0,6.025,1.975v9.037a.469.469,0,0,0,.75.375L8.658,9.975h5.367A1.974,1.974,0,0,0,16,8V1.975A1.974,1.974,0,0,0,14.025,0Zm1.037,8a1.037,1.037,0,0,1-1.037,1.037H8.5a.469.469,0,0,0-.281.094l-1.258.944v-8.1A1.037,1.037,0,0,1,8,.938h6.025a1.037,1.037,0,0,1,1.037,1.037Zm0,0",
    fill: "#8391a2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQA);
export default __webpack_public_path__ + "static/media/q-a.9c901e0c1a4c7fbdce0c0f5b7b12aa45.svg";
export { ForwardRef as ReactComponent };